import { render, staticRenderFns } from "./TransactionVolumes.vue?vue&type=template&id=d755691e&scoped=true&"
import script from "./TransactionVolumes.vue?vue&type=script&lang=js&"
export * from "./TransactionVolumes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d755691e",
  null
  
)

export default component.exports